import React from 'react';
import {
  ComponentVerticalSpacing,
  ComponentWrapper,
  Toggle,
  Card,
  CardSlider,
  Modal
} from 'day8-react/build/new-components';
import PropTypes from 'prop-types';

const Team = props => {
  const { data } = props;
  return (
    <ComponentVerticalSpacing>
      <ComponentWrapper>
        <h2 className="text-center margin-y-lg">Meet the team</h2>
        <CardSlider>
          {data.map(item => (
            <Toggle key={JSON.stringify(item)}>
              {({ toggle, on }) => (
                <React.Fragment>
                  <Card
                    template="ImageCard"
                    imageCardTemplate="VerticalSplit"
                    title={item.title.rendered}
                    image={{ url: item.featured_image_src, alt: item.title.rendered }}
                    heading={item.position}
                    noJustifyEnd
                    subheading={item.excerpt.rendered}
                    size="xl"
                    titleSize="text-md"
                  />
                  <Modal on={on} toggle={toggle} title={item.title.rendered} text={item.content.rendered} />
                </React.Fragment>
              )}
            </Toggle>
          ))}
        </CardSlider>
      </ComponentWrapper>
    </ComponentVerticalSpacing>
  );
};


Team.propTypes = {
  data: PropTypes.object
};

export default Team;
